import {useCallback, useEffect, useState} from "react";
import {Reactions} from "~/customers-experience/triggers";
import {addListener, getReactions, removeListener} from "./provider";


export function useReactions() {
    const [reactions, setReactions] = useState<Reactions>(getReactions());

    const handleReaction = useCallback((reactions) => {
        setReactions(reactions);
    }, []);

    useEffect(() => {
        addListener(handleReaction);
        return () => removeListener(handleReaction);
    }, []);

    return reactions;
}